import { render } from "./SimpleHeaderDesktop.vue?vue&type=template&id=23259b7a&scoped=true"
import script from "./SimpleHeaderDesktop.vue?vue&type=script&lang=js"
export * from "./SimpleHeaderDesktop.vue?vue&type=script&lang=js"

import "./SimpleHeaderDesktop.vue?vue&type=style&index=0&id=23259b7a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23259b7a"]])

export default __exports__